export default __webpack_public_path__ + "static/media/worldmap.7e04ad69.png";